import React from "react";

function Whychoosetest() {
  return (
    <div className="whychoosee">
      <div class="container">
        <div class="why-choose-area  pb-100">
          <div class="container">
            <div
              class="row justify-content-center"
              data-cues="slideInUp"
              data-disabled="true"
            >
              <div
                class="col-lg-3 col-md-6"
                data-cue="slideInUp"
                data-show="true"
                style={{
                  animationName: "slideInUp",
                  animationDuration: "600ms",
                  animationTimingFunction: "ease",
                  animationDelay: "0ms",
                  animationDirection: "normal",
                  animationFillMode: "both",
                }}
              >
                <div class="why-choose-content">
                  <span class="sub">Trusted Since 2000</span>
                  <h2>
                    <b>Why Choose Gateway Landmark Group?</b>
                  </h2>
                </div>
              </div>
              <div
                class="col-lg-3 col-md-6"
                data-cue="slideInUp"
                data-show="true"
                style={{
                  animationName: "slideInUp",
                  animationDuration: "600ms",
                  animationTimingFunction: "ease",
                  animationDelay: "180ms",
                  animationDirection: "normal",
                  animationFillMode: "both",
                }}
              >
                <div class="why-choose-card">
                  <div class="image">
                    <img src="/img/why-choose1.png" alt="image" />
                  </div>
                  <h3>
                    <b>Quality building </b>
                  </h3>
                  <p>
                    At Gateway LANDMARK GROUP, we focus on quality building,
                    ensuring every structure meets the highest standards of
                    durability and excellence, providing reliable and
                    long-lasting solutions.
                  </p>
                </div>
              </div>
              <div
                class="col-lg-3 col-md-6"
                data-cue="slideInUp"
                data-show="true"
                style={{
                  animationName: "slideInUp",
                  animationDuration: "600ms",
                  animationTimingFunction: "ease",
                  animationDelay: "360ms",
                  animationDirection: "normal",
                  animationFillMode: "both",
                }}
              >
                <div class="why-choose-card">
                  <div class="image">
                    <img src="/img/why-choose2.png" alt="image" />
                  </div>
                  <h3>
                    <b>Dispute Free Properties</b>
                  </h3>
                  <p>
                    At Gateway LANDMARK GROUP, our 100% dispute-free properties
                    offer peace of mind with transparent transactions and timely
                    delivery.
                  </p>
                </div>
              </div>
              <div
                class="col-lg-3 col-md-6"
                data-cue="slideInUp"
                data-show="true"
                style={{
                  animationName: "slideInUp",
                  animationDuration: "600ms",
                  animationTimingFunction: "ease",
                  animationDelay: "540ms",
                  animationDirection: "normal",
                  animationFillMode: "both",
                }}
              >
                <div class="why-choose-card">
                  <div class="image">
                    <img src="/img/why-choose3.png" alt="image" />
                  </div>
                  <h3>
                    <b>Best Investment Options</b>
                  </h3>
                  <p>
                    Our properties provide excellent returns on investment and
                    foster long-term wealth creation, all with flexible and
                    attractive payment plans.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Whychoosetest;
